module.exports = __webpack_public_path__ + "img/icon17.9417289a.png";